import React, { useEffect, useState } from "react";
import ImgComp from "../Component/ImgComp";
import PaymentContent from "../Modules/PaymentContent";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PaymentContentNew from "../Modules/PaymentContentNew";
import axios from "axios";
import { adminapiUrl } from "../Utils/constants";
import { getContentTypeByCategoryUid } from "../Utils/content";

const PaymentPage = () => {

  const [userDetailsState,setUserDetails] = useState()
  const storeSel = useSelector((state) => state);
  const userDetails = storeSel?.UrlData?.userDetails;
  const navigate = useNavigate();

  
  const [categorySlug, setCategorySlug] = useState(null);
  const [categories, setCategories] = useState(null);
  const { category } = useParams();

  const [categoriesMap, setCategoriesMap]  = useState({});

  useEffect(()=>{
    setUserDetails(userDetails)
  },[])

  useEffect(() => {
    if (
      userDetails &&
      userDetails?.startdate === null ||
      userDetails?.name === null 
    ) {
      const pathSegments = window.location.pathname.split('/');      
      // Remove the last segment to go back one level
      pathSegments.pop();    

      // Construct the new URL
      const newUrl = pathSegments.join('/');    

      // Navigate to the new URL
      navigate(newUrl);
    }
  }, [userDetailsState]);

  
  useEffect(() => {
    // const queryParams = new URLq(window.location.search);

    // console.log("query_params => ", queryParams)

    // const catSlug = queryParams.get("category")

    if(category) setCategorySlug(category)
    
      console.log("Cat slug --->", category)

      const getCategories = async () => {
        const res = await axios.get(
          adminapiUrl+"/read_allbranch_alltypes_allplans",
          // "https://admin-api.bodyprocoach.com/admin/read_allbranch_alltypes_allplans",
          {
            headers: {
              "Content-Type": "application/json",
            },
            mode: "no-cors",
          }
        );
    
        const data = res.data.data;
        setCategories(data?.All_categories);
        if(data?.All_categories) {
          const cat_slug_map = {}
          data?.All_categories.map((cat) => {
            cat_slug_map[cat.slug] = getContentTypeByCategoryUid(cat?.uid)
          })
          console.log("CAT SLUG MAP --> ", cat_slug_map)
          setCategoriesMap(cat_slug_map);
        }

        console.log("categories in sessions => ", data);
      };
      getCategories();

  }, [category]);

  
  useEffect(() => {
    if(categoriesMap && categorySlug) {
    if(categoriesMap[categorySlug]) document.documentElement.style.setProperty('--global-theme', 'black');
    }
  }, [categorySlug, categoriesMap])

  const selectedAppName = getContentTypeByCategoryUid(
    categories?.find(cat => cat?.slug == categorySlug)?.uid
  );
  
  return (
    <>
      <div className="home-page payment-page start-page">
      {categoriesMap[categorySlug] ? (
      <>
        <ImgComp />

        <PaymentContentNew  appname = {selectedAppName} />
        </>
      ) : <p>Loading...</p>}
      </div>
    </>
  );
};

export default PaymentPage;
